import React from 'react'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import TaskCard from 'modules/processes/components/ItemWizard/components/ItemCard'
import { TaskTypes } from 'modules/processes/hooks/types'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

interface Props {
  onSelect: (taskType: TaskTypes) => void
}

const Selector = ({ onSelect }: Props) => {
  const { itemType } = useItemProvider()

  return (
    <TaskCard
      title={i18n.t('processes.process_settings.wizard.tasks.types.sign_documents.title')}
      description={i18n.t(
        'processes.process_settings.wizard.tasks.types.sign_documents.description'
      )}
      onSelect={() => {
        onSelect(TaskConfigurationTypes.SignDocuments)
      }}
      itemType={TaskConfigurationTypes.SignDocuments}
      value={itemType}
    />
  )
}

export default Selector
